import { GeistSans } from "geist/font/sans"
import { Halant, Courier_Prime } from "next/font/google"

export const geistSans = GeistSans

export const halant = Halant({
  subsets: ["latin"],
  variable: "--font-halant",
  weight: ["300", "400", "500", "600", "700"],
})

export const courierPrime = Courier_Prime({
  subsets: ["latin"],
  variable: "--font-courier-prime",
  weight: ["400", "700"],
})
